import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { Card, Icon, Stepper, Text } from "~/components-shared";
import { MemberStatusEnum } from "~/types/enums";
import { Transition, TransitionGroup } from "react-transition-group";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
import { onboardingOrder } from "~/lib/helpers";
import OnboardingTopicsIdentify from "~/components/OnboardingTopicsIdentify";
import OnboardingTopicsCreate from "~/components/OnboardingTopicsCreate";
import OnboardingTopicsRetro from "~/components/OnboardingTopicsRetro";
import OnboardingTopicsBegin from "~/components/OnboardingTopicsBegin";
import { enterSideBar, exitSideBar } from "~/lib/animations";
import { useIntegratedSources } from "~/hooks/topics";
const StyledIcon = styled(Icon)`
  box-shadow: inset 0 0 0 6px ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.success.main;
}};
  border-radius: 50%;
`;
const OnboardingTopicsCard = _ref2 => {
  let {
    open,
    ...rest
  } = _ref2;
  const {
    colors
  } = useTheme();
  const user = useSelector(authSelectors.getUser);
  const success = user?.status && onboardingOrder[user.status] > onboardingOrder[MemberStatusEnum.ONBOARDING_CREATE_TOPICS];
  const [template, setTemplate] = useState();
  const [topic, setTopic] = useState();
  const [stepId, setStepId] = useState(0);
  const sources = useIntegratedSources();
  const includeRetro = !!sources.length;
  const stepper = [{
    id: 1,
    value: /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      weight: "semiBold"
    }, "Identify Initiative")
  }, {
    id: 2,
    value: /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      weight: "semiBold"
    }, "Create Topic")
  }];
  if (includeRetro) {
    stepper.push({
      id: 3,
      value: /*#__PURE__*/React.createElement(Text, {
        fontSize: 3.5,
        color: "textSecondary",
        weight: "semiBold"
      }, "Ingest Data")
    });
  }
  const handleStepBack = id => {
    if (id < stepId) {
      setStepId(id);
    }
  };
  // Todo Check if there are no active integrations then only skip this step
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      px: 10,
      py: 6,
      mb: 10
    },
    collapsed: !open,
    elemAfter: success ? /*#__PURE__*/React.createElement(StyledIcon, {
      src: "checkboxFill",
      scale: 8,
      color: colors.success.main
    }) : undefined,
    shadow: true
  }, rest), /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: stepId,
    onEnter: node => enterSideBar(node),
    onExit: node => exitSideBar(node),
    timeout: {
      enter: 750,
      exit: 400
    },
    appear: true
  }, /*#__PURE__*/React.createElement("div", null, stepId === 0 ? /*#__PURE__*/React.createElement(OnboardingTopicsBegin, {
    onSuccess: () => setStepId(1)
  }) : /*#__PURE__*/React.createElement(Stepper, {
    maxWidth: "400px",
    activeValue: stepId,
    onChange: handleStepBack,
    data: stepper,
    s: {
      my: 6
    }
  }), stepId === 1 && /*#__PURE__*/React.createElement(OnboardingTopicsIdentify, {
    onSuccess: newTemplate => {
      setTemplate(newTemplate);
      setStepId(2);
    }
  }), stepId === 2 && template && /*#__PURE__*/React.createElement(OnboardingTopicsCreate, {
    template: template,
    onBack: () => setStepId(1),
    onSuccess: newTopic => {
      setTopic(newTopic);
      setStepId(3);
    }
  }), stepId === 3 && topic && /*#__PURE__*/React.createElement(OnboardingTopicsRetro, {
    topic: topic,
    onBack: () => setStepId(2),
    onSuccess: () => setStepId(3)
  })))));
};
export default OnboardingTopicsCard;